<template>
  <modal :modal-key="'welcome-returning-modal'"
         :class-style="'modal--welcomeback modal--zero-balance modal--purchase'"
         @close="$emit('close')">
    <template slot="header">
      <h1>{{ getTranslations.home_modals_welcome_back_returning_back_welcome_back }} {{ userDetails.username }}!</h1>
      <img class="usericon" src="static/images/happy_face.svg" alt="">
    </template>
    <template slot="body">
      <p>{{ getTranslations.home_modals_welcome_back_returning_back_you_start }}</p>
    </template>
  </modal>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import Modal from '@/components/home/modals/shared/GenericModal';

export default {
  // modal_returning_unsubscribed.html
  name: 'welcome-returning-unsub',
  components: {
    Modal,
  },
  computed: {
    ...mapState('common', [
      'userDetails',
    ]),
    ...mapGetters('i18n', [
      'getTranslations',
    ]),
  },
};
</script>



// WEBPACK FOOTER //
// src/components/home/modals/WelcomeReturningUnsub.vue